// extracted by mini-css-extract-plugin
export default {"emoji":"Emoji_emoji__XcesH"};